module.exports = __webpack_public_path__ + "img/customer6.710039e2.png";